var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"page-spinner"},[_c('div',{staticClass:"base-spinner img-fluid"},[_c('lottie-animation',{attrs:{"path":"./sh-spinner.json","loop":true}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }